import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from 'app/_services/file.service';
import { SessionsService } from 'app/_services/sessions.service';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-session-photo-modal',
  templateUrl: './session-photo-modal.component.html',
})
export class SessionPhotoModalComponent implements OnInit, OnDestroy {
  public sessionId?: any; // passed in when modal is created
  public workOrderId?: any; // passed in when modal is created

  public title = 'Session';
  public uploads: any;
  private lightBoxPhotos: any[] = [];
  private downloadButtonReady: boolean[] = [];

  constructor(
    private sessionsService: SessionsService,
    private fileService: FileService,
    private lightbox: Lightbox,
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    if (this.workOrderId) {
      this.sessionsService.getSiteSessionByWorkOrderId(this.workOrderId).subscribe(data => {

        this.title = `WO #${data.workOrder.id} - ${data.workOrder.description}`;
        this.uploads = data.siteSessionUploads;

        this.preparePhotos();
      });

    } else if (this.sessionId) {
      this.sessionsService.getUserSessionById(this.sessionId).subscribe(data => {
        this.title = data.siteSession.workOrder ? `WO #${data.siteSession.workOrder.id} - ${data.siteSession.workOrder.description}` : 'Site Session';
        this.uploads = data.siteSession.siteSessionUploads;

        this.preparePhotos();
      })

    } else {
      console.error('Needs work order id or user session id to find photos');
    }
  }

  private preparePhotos() {
    let photoTotalIndex = 0;
    const httpCalls = [];

    this.downloadButtonReady = [];
    for (const photoUploadGroup of this.uploads) {
      for (const photo of photoUploadGroup.files) {
        photo.photoTotalIndex = photoTotalIndex;
        photoTotalIndex++;

        this.downloadButtonReady.push(false);
        httpCalls.push(this.fileService.getSiteSessionPhoto(photo.fileName).toPromise().then(photoData => {
          photo.srcPath = photoData.safeUrl;
          photo.objectUrl = photoData.objectUrl;

          photo.loaded = true;
          this.downloadButtonReady[photo.photoTotalIndex] = true;

          this.lightBoxPhotos.push({ src: photoData.safeUrl, caption: photo.fileName, index: photo.photoTotalIndex });
        }).catch(error => {
          console.error(error);
        }));
      }
    }

    // lightBoxPhotos array could be created out of order as http calls return. sort by index
    Promise.all(httpCalls).then(() => {
      this.lightBoxPhotos.sort((a, b) => a.index - b.index);
    });
  }

  ngOnDestroy(): void {
    this.fileService.releaseObjectUrls();
  }

  public viewPhotos(index: number) {
    this.lightbox.open(
      this.lightBoxPhotos,
      index,
      { showImageNumberLabel: true, wrapAround: true, centerVertically: true }
    );
  }

  public downloadAll() {
    for (const photoUploadGroup of this.uploads) {
      for (const photo of photoUploadGroup.files) {
        this.fileService.downloadFile(photo.objectUrl, photo.fileName);
      }
    }
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public isDownloadButtonReady() {
    return this.downloadButtonReady.length > 0 && this.downloadButtonReady.every(ready => ready);
  }
}
